import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'insights',
        path: '/dashboards/insights',
        component: () => import('@/pages/edverum-insights/EdverumInsights.vue'),
        props: false,
        children: [
            {
                name: 'insights-bell-curve',
                path: 'bell-curve',
                component: () => import('@/pages/bell-curve/BellCurveParent.vue'),
                meta: {
                    dataTablePage: true,
                },
            },
        ],
        beforeEnter: FeatureMiddleware('INSIGHTS'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) =>
                gateKeeper.userHasPermission('view insight dashboard') ||
                gateKeeper.userHasGroupPermission('view insight dashboard') ||
                gateKeeper.userIsGroupInstructor(),
        },
    },
];
